<template>
    <div id="bloco-inserir-territorio-certificacao">
        <h1>
            {{ $tc('certification.messages.insert_territory_data_manually') }}
        </h1>
        <el-card>
            <div class="box-card-inserir-territorio-manual">
                <div class="box-card-inserir-territorio-manual__conteudo">
                    <div
                        class="box-card-inserir-territorio-manual__conteudo__bloco"
                    >
                        <span>{{
                            $tc(
                                'certification.messages.search_territory_to_add'
                            )
                        }}</span>
                    </div>
                    <el-alert type="info" show-icon :closable="false">
                        {{ $tc('certification.messages.info_cpf_cnpj') }}
                    </el-alert>
                    <div
                        class="box-card-inserir-territorio-manual__conteudo__bloco"
                    >
                        <el-form
                            class="box-card-inserir-territorio-manual__conteudo__bloco_pesquisa"
                            label-position="top"
                            :model="formularioCadastroCertificacao"
                            :rules="formularioCadastroCertificacaoRegras"
                            ref="formularioCadastroCertificacao"
                        >
                            <div
                                class="box-card-inserir-territorio-manual__conteudo__bloco_pesquisa-por-territorio"
                            >
                                <el-form-item prop="territorioSelecionado">
                                    <template #label>
                                        <span>{{
                                            $tc(
                                                'certification.messages.search_for_territory'
                                            )
                                        }}</span>
                                    </template>
                                    <el-select
                                        class="input-territorio"
                                        v-model="
                                            formularioCadastroCertificacao.territorioSelecionado
                                        "
                                        :loading="buscandoTerritorio"
                                        :loading-text="textoBuscandoTerritorio"
                                        filterable
                                        remote
                                        clearable
                                        @clear="limparTerritorios"
                                        reserve-keyword
                                        :placeholder="
                                            $tc(
                                                'certification.messages.search_placeholder'
                                            )
                                        "
                                        remote-show-suffix
                                        :remote-method="fetchTerritorios"
                                        @keydown.native.enter="
                                            validarTerritorio
                                        "
                                    >
                                        <el-option
                                            v-for="territorio in territorios"
                                            :key="
                                                territorio.nome + territorio.id
                                            "
                                            :label="
                                                territorio.nome.toUpperCase()
                                            "
                                            :value="territorio.id"
                                        ></el-option>
                                        <template
                                            v-if="
                                                inputValue.length >= 3 &&
                                                territorios === null &&
                                                !buscandoTerritorio
                                            "
                                            #empty
                                        >
                                            <div
                                                v-if="!verificarCar(inputValue)"
                                                class="inserir-territorio-manual-sem-resultado"
                                            >
                                                <p>
                                                    {{
                                                        $tc(
                                                            'certification.messages.no_results_found'
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <div
                                                class="inserir-territorio-manual-sem-resultado-cadastro-car"
                                            ></div>
                                        </template>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div
                        class="box-card-inserir-territorio-manual__conteudo__bloco_alerta_cadastro_territorio"
                    ></div>
                    <div
                        class="box-card-inserir-territorio-manual__conteudo__bloco alinhar-rigth"
                    >
                        <div
                            class="box-card-inserir-territorio-manual__conteudo__bloco__buttons"
                        >
                            <el-button
                                id="adicionar-territorio-lista"
                                type="primary"
                                icon="el-icon-plus"
                                @click.prevent="validarTerritorio"
                            >
                                {{
                                    $tc(
                                        'certification.messages.add_new_territory'
                                    )
                                }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import CarUtils from '@/utils/CarUtils';
import CertificacaoService from '@/services/CertificacaoService';

export default {
    name: 'BlocoInserirManualmenteCertificacao',
    components: {},

    data() {
        const validardorTerritorio = (rule, value, callback) => {
            if (
                value === '' ||
                this.formularioCadastroCertificacao.territorioSelecionado === ''
            ) {
                callback(new Error('Valor inválido. VAZIO'));
            }

            callback();
        };

        return {
            formularioCadastroCertificacao: {
                territorioSelecionado: ''
            },
            formularioCadastroCertificacaoRegras: {
                territorioSelecionado: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: validardorTerritorio
                    }
                ]
            },
            territorios: [],
            buscandoTerritorio: true,
            inputValue: '',
            textoBuscandoTerritorio: 'Mínimo 3 caracteres'
        };
    },

    methods: {
        async fetchTerritorios(filtro) {
            this.buscandoTerritorio = true;

            if (filtro.length < 3) {
                this.textoBuscandoTerritorio = 'Mínimo 3 caracteres';
                this.territorios = [];
                this.inputValue = '';
                return;
            }

            this.textoBuscandoTerritorio = 'Carregando...';
            this.inputValue = filtro;

            try {
                this.buscandoTerritorio = true;
                const { data } =
                    await CertificacaoService.buscarTerritorioFiltroCertificacao(
                        filtro
                    );
                if (CarUtils.isCar(filtro) && data.itens === null) {
                    this.formularioCadastroCertificacao.territorioSelecionado =
                        CarUtils.addMascaraCar(filtro);
                    this.inputValue = filtro;
                    this.buscandoTerritorio = false;
                    this.territorios = [];
                } else {
                    this.territorios = data.itens;
                }
                this.buscandoTerritorio = false;
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar dados de território.'
                });
            }
        },

        verificarCar(valor) {
            return CarUtils.isCar(valor);
        },

        limparTerritorios() {
            this.territorios = [];
        },

        validarTerritorio() {
            this.$refs['formularioCadastroCertificacao'].validate(valid => {
                if (valid) {
                    this.emitirAdicionarCertificacaoNaoEnviadaLista();
                } else {
                    return false;
                }
            });
        },

        emitirAdicionarCertificacaoNaoEnviadaLista() {
            let dadosTerritorio;
            if (this.territorios.length) {
                dadosTerritorio = this.territorios.filter(objeto => {
                    return (
                        objeto.id ===
                        this.formularioCadastroCertificacao
                            .territorioSelecionado
                    );
                });
            } else {
                dadosTerritorio = [
                    this.formularioCadastroCertificacao.territorioSelecionado
                ];
            }

            this.$emit('adicionarCertificacaoNaoEnviada', dadosTerritorio[0]);
            this.$refs['formularioCadastroCertificacao'].resetFields();
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-territorio-certificacao {
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card.is-always-shadow {
        min-height: 375px;
    }

    el-card {
        margin-top: 10px;
        display: flex;
    }

    .box-card-inserir-territorio-manual {
        height: 333px;
    }

    .box-card-inserir-territorio-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        min-height: 325px;
        justify-content: space-between;

        .box-card-inserir-territorio-manual__conteudo__bloco {
            margin-bottom: 15px;
            display: flex;
            font-size: 16px;
            justify-content: flex-start;
            &.alinhar-rigth {
                justify-content: flex-end;
            }

            .box-card-inserir-territorio-manual__conteudo__bloco__buttons {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
            }
        }
        .el-alert .el-alert__description {
            margin: 0 0 0 0;
        }
    }

    .box-card-inserir-territorio-manual__conteudo__bloco_pesquisa {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        width: 100%;

        .box-card-inserir-territorio-manual__conteudo__bloco_pesquisa-por-territorio {
            display: flex;
            flex-direction: column;

            input {
                width: 661px;
            }
        }
    }
}
.inserir-territorio-manual-sem-resultado {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 5px;
    text-align: center;
    justify-content: center;
    p {
        padding: 0;
        margin-top: 7px;
        margin-bottom: 5px;
    }
    .btn-cadastro {
        border-radius: 20px !important;
        color: #000000;
    }
}
.el-select-dropdown.el-popper
    > .inserir-territorio-manual-sem-resultado-cadastro-car,
.inserir-territorio-manual-sem-resultado-cadastro-car + .popper__arrow {
    display: none !important;
    min-width: 0px !important;
}

.el-select-dropdown.el-popper {
    margin-top: 25px;
}
</style>
